require('tinymce')
require('tinymce/themes/modern/theme')
require('tinymce/plugins/preview')
require('tinymce/plugins/paste')
require('tinymce/plugins/print')
require('tinymce/plugins/fullscreen')
require('tinymce/plugins/fullpage')
require('tinymce/plugins/searchreplace')
require('tinymce/plugins/autoresize')
require('tinymce/plugins/table')
require('tinymce/plugins/lists')
require('tinymce/plugins/autosave')
require('tinymce/plugins/code')
require('tinymce/plugins/template')
require('tinymce/plugins/contextmenu')
require('tinymce/plugins/image')
require('tinymce/plugins/imagetools')
require('tinymce/plugins/textcolor')
require('tinymce/plugins/textpattern')
require('tinymce/plugins/noneditable')
require('tinymce/plugins/visualblocks')
require('tinymce/plugins/pagebreak')
require('./plugins/stickytoolbar')